import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ECardListCategory } from "@app/core/consts/card-list.const";
import { CardViewActionType } from "@app/core/consts/list-management.const";
import { CardViewAction } from "@app/core/models/list-management";
import { Translations } from "@app/core/services/i18n/translations.service";
import { PersistTooltipService } from "@app/core/services/persist-tooltip.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() category: string = '';
  @Input() data;

  cardCategory = ECardListCategory;

  constructor(
    private router: Router,
    private tooltipService: PersistTooltipService,
    public translateService: TranslateService,
    public translations: Translations,
  ) {}

  onNavigate(link) {
    this.router.navigate([link]);
  }

  onTriggerButton(action: CardViewAction, row) {
    if (action?.type === CardViewActionType.FUNCTION && action.func && row) {
      action.func(row);
    }
  }
}
